<template>
    <v-row class="ma-0 pa-0">
        <v-col class="ma-0 pa-0" cols="auto">
            <span class="chart_title">{{ statistic_title_name == null ? statistic_name : statistic_title_name }}</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="ma-0 pa-0" cols="auto">
            <v-btn icon v-if="link">
                <v-icon color="secondary" @click="open_further_details">mdi-magnify-expand</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" class="py-0 chart_style_b" v-if="tall">
            <v-chart :id="chart_id" class="chart" :option="option" autoresize></v-chart>
        </v-col>
        <v-col cols="12" class="py-0 chart_style" v-else>
            <v-chart :id="chart_id" class="chart" :option="option" autoresize></v-chart>
        </v-col>
    </v-row>
</template>

<script>
    import VChart, { THEME_KEY } from 'vue-echarts';
    import "echarts";
    import { use } from 'echarts/core';
    import { CanvasRenderer } from 'echarts/renderers';
    import { BarChart as EBarChart } from 'echarts/charts';
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    } from 'echarts/components';
    import {COLOR_PALETTE} from "./chart_constants.js"

    use([
        CanvasRenderer,
        EBarChart,
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    ]);
    
    export default {
        name: 'BarChart',
        props: [
            'statistic_title_name',
            'value',
            'link',
            'chart_id',
            'tall'
        ],
        components: {
            VChart
        },
        provide: {
            [THEME_KEY]: 'light',
        },
        setup(props) {

            let dataset = props.value;

            let data_category = []
            let data_value = [];
            if(dataset != null){
                for(let idx = 1; idx < dataset.length; idx ++){
                    data_category.push(dataset[idx][0]);
                    data_value.push(dataset[idx][1]);
                }
            }
            const total_value = data_value.reduce((sum, value) => sum + value, 0);

            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: function(params) {
                        const { axisValue, value } = params[0];
                        const percentage = total_value > 0 ? ((value / total_value) * 100).toFixed(1) : '0.0';
                        return `<b>${axisValue}</b><br/>Value: ${value}<br/>Percentage: ${percentage}%`;
                    },
                    borderWidth: 3,
                    textStyle: {
                        fontFamily: 'Gothic'
                    },
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    top: '0%',
                    left: '3%',
                    right: '10%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'value'
                    }
                ],
                yAxis: [
                    {
                        type: 'category',
                        data: data_category,
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                series: [
                    {
                    type: 'bar',
                    barWidth: '60%',
                    data: data_value,
                    color: COLOR_PALETTE,
                    label: {
                        show: true,
                        position: 'right',
                        color: '#333',
                        fontFamily: 'Gothic',
                        fontSize: 14,
                        formatter: ({ value }) => {
                            const percentage = total_value > 0 ? ((value / total_value) * 100).toFixed(1) : '0.0';
                            return `${value} (${percentage}%)`;
                        }
                    }
                    },
                ],
            }
            return {option}
        },
        methods: {
            open_further_details: function(){
                if(this.link){
                    this.$router.replace(this.link);
                }
            }
        }
    }
</script>

<style scoped>
    .chart_title{
        font-family: "Gothic Bold" !important;
        font-size: 10pt !important;
        line-height: 40px;

        display: block;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chart_style{
        height: 200px;
        font-family: "Gothic" !important;
    }
    .chart_style_b{
        height: 450px;
        font-family: "Gothic" !important;
    }
</style>
